module.exports = __webpack_public_path__ + "static/media/icon_mono_default.5a4761ad.svg";